// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=171dc29c-5366-437f-8529-4a0dcb6aa2c8";
};